import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-[34px] h-11 leading-11 font-bold mb-4" }, " Запреты на меню ", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Запретить категорию ")

import { ref, computed } from "vue";

import { useBans } from "@/use/useBans";
import { useAsync } from "@/use/useAsync";
import { IBan } from "@/types/ban";

import UiApp from "@/plugins/ui/components/app/UiApp.vue";
import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiHeader from "@/plugins/ui/components/header/UiHeader.vue";
import UiSuspense from "@/plugins/ui/components/suspense/UiSuspense.vue";

import UiCheckbox from "@/components/ui/UiCheckbox.vue";
import UiIcon from "@/components/ui/UiIcon.vue";
import UiSwitch from "@/components/ui/UiSwitch.vue";
import UiTab from "@/components/ui/UiTab.vue";
import UiTabs from "@/components/ui/UiTabs.vue";

import AppSidebar from "@/components/AppSidebar.vue";
import AppTabbar from "@/components/AppTabbar.vue";
import AppTopBar from "@/components/AppTopBar.vue";
import UiAppbar from "@/plugins/ui/components/appbar/UiAppbar.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import UiIconBtn from "@/components/ui/UiIconBtn.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Bans',
  setup(__props) {

const {
  lockPositions,
  fetchBans,
  fetchLockPositions,
  addBan,
  removeBan,
  isFoodBanned,
  isTypeBanned,
} = useBans();

const selectedFoodType = ref(-1);
const setSelectedFoodType = (id: number) => (selectedFoodType.value = id);

const fetchData = useAsync(
  () =>
    Promise.all([fetchBans(), fetchLockPositions()]).then(
      () => (selectedFoodType.value = lockPositions.value[0]?.id)
    ),
  true
);

const filteredFoods = computed(
  () =>
    lockPositions.value.find(
      (foodType) => foodType.id === selectedFoodType.value
    )?.foods || []
);

function handleBanFood(foodId: number) {
  const ban: IBan = { lockId: foodId, lockType: "food" };
  isFoodBanned(foodId, selectedFoodType.value) ? removeBan(ban) : addBan(ban);
}

function handleBanType() {
  const ban: IBan = { lockId: selectedFoodType.value, lockType: "type" };
  isTypeBanned(selectedFoodType.value) ? removeBan(ban) : addBan(ban);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UiApp, null, {
    header: _withCtx(() => [
      _createVNode(UiAppbar, {
        temporary: "",
        title: "Запреты на меню"
      }, {
        right: _withCtx(() => [
          _createVNode(UiIconBtn, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/settings'))),
            variant: "tertiary",
            icon: "Cog"
          })
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(AppTabbar)
    ]),
    sidebar: _withCtx(() => [
      _createVNode(AppSidebar)
    ]),
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(UiSuspense, {
        onRetry: _cache[2] || (_cache[2] = ($event: any) => (_unref(fetchData).execute())),
        pending: _unref(fetchData).isPending.value,
        failure: _unref(fetchData).isFailure.value,
        success: _unref(fetchData).isSuccess.value,
        variant: "screen",
        "has-retry": ""
      }, {
        default: _withCtx(() => [
          _createVNode(UiTabs, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(lockPositions), (foodType) => {
                return (_openBlock(), _createBlock(UiTab, {
                  onClick: ($event: any) => (setSelectedFoodType(foodType.id)),
                  key: foodType.id,
                  active: foodType.id === selectedFoodType.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(foodType.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick", "active"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(UiGroup, null, {
            default: _withCtx(() => [
              _createVNode(UiCard, null, {
                default: _withCtx(() => [
                  _createVNode(UiCell, null, {
                    left: _withCtx(() => [
                      _createVNode(UiIcon, { icon: "Ban" })
                    ]),
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    right: _withCtx(() => [
                      _createVNode(UiSwitch, {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (handleBanType())),
                        modelValue: _unref(isTypeBanned)(selectedFoodType.value)
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(UiCard, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredFoods), (food) => {
                    return (_openBlock(), _createBlock(UiCell, {
                      key: food.id,
                      multiline: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(food.name), 1)
                      ]),
                      right: _withCtx(() => [
                        _createVNode(UiSwitch, {
                          "onUpdate:modelValue": ($event: any) => (handleBanFood(food.id)),
                          modelValue: _unref(isFoodBanned)(food.id, selectedFoodType.value!)
                        }, null, 8, ["onUpdate:modelValue", "modelValue"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["pending", "failure", "success"])
    ]),
    _: 1
  }))
}
}

})